
import {
  STRIPE_PERCENT_FEE,
  STRIPE_FIXED_FEE,
  BANK_STRIPE_PERCENT_FEE,
  BANK_STRIPE_FIXED_FEE,
  BANK_STRIPE_MAX_FEE,
  KEEP_MORE_PERCENT_FEE
} from '../constants';

/**
 * Calculate Stripe's processing fee
 */
export const calculateStripeFee = (grossAmount: number, paymentMethod: 'card' | 'bank' = 'card'): number => {
  const stripePercentage = paymentMethod === 'bank' ? BANK_STRIPE_PERCENT_FEE : STRIPE_PERCENT_FEE;
  const stripeFixedFee = paymentMethod === 'bank' ? BANK_STRIPE_FIXED_FEE : STRIPE_FIXED_FEE;
  
  // Convert to cents for integer math
  const grossAmountCents = Math.round(grossAmount * 100);
  const stripeFixedFeeCents = Math.round(stripeFixedFee * 100);
  
  // Calculate fee in cents with single rounding step
  let stripeFeeCents = Math.round(grossAmountCents * stripePercentage) + stripeFixedFeeCents;
  
  // Apply maximum fee cap for bank payments
  if (paymentMethod === 'bank') {
    const maxFeeCents = Math.round(BANK_STRIPE_MAX_FEE * 100);
    stripeFeeCents = Math.min(stripeFeeCents, maxFeeCents);
  }
  
  // Convert back to dollars
  return stripeFeeCents / 100;
};

/**
 * Calculate KeepMore's platform fee
 */
export const calculateKeepMoreFee = (grossAmount: number, paymentMethod: 'card' | 'bank' = 'card'): number => {
  if (paymentMethod === 'bank') return 0;
  
  // Convert to cents for integer math
  const grossAmountCents = Math.round(grossAmount * 100);
  
  // Calculate fee in cents with single rounding step
  const keepMoreFeeCents = Math.round(grossAmountCents * KEEP_MORE_PERCENT_FEE);
  
  // Convert back to dollars
  return keepMoreFeeCents / 100;
};

/**
 * Calculate application fee for Stripe Connect 
 * This is an alias for calculateKeepMoreFee for backward compatibility
 */
export const calculateApplicationFeeAmount = (grossAmount: number, paymentMethod: 'card' | 'bank' = 'card'): number => {
  return calculateKeepMoreFee(grossAmount, paymentMethod);
};

/**
 * Legacy alias for calculateKeepMoreFee
 * Explicitly defined here to ensure it's exported correctly
 */
export const calculatePlatformFee = calculateKeepMoreFee;
